// extracted by mini-css-extract-plugin
module.exports = {"root":"FilesBlock_root__Pvmd9"};